import type { AppContext } from '../../game/context.js';
import { reviewDue, type ReviewMoment } from '../../services/review.js';
import { currentStep } from '../../services/firstSession.js';
import type { FeatureManifest } from '../registry.js';

/**
 * The store's in-app rating sheet (services/review.ts has the rules): asked on a calm map visit after
 * the 3rd level win or the first shop upgrade, once more after 30 days and 20 wins. No view of its
 * own: the sheet is the store's. Last among the map hooks, so every popup of the visit has closed.
 */
export default {
  id: 'review',
  flag: 'reviewPrompt',
  provides: [],
  mapOrder: 90,
  mapDue: (a) => !a.session.checked.has('review') && reviewDue(a.services.store.state, moment(a)) !== null,
  load: () => import('./index.js'),
} satisfies FeatureManifest;

/** The rules' view of this map visit. */
export function moment(a: AppContext): ReviewMoment {
  return {
    now: a.services.now(),
    flag: a.remote.flags.reviewPrompt !== false,
    available: a.services.providers.review.available,
    rescueOpen: a.ui.modals.some((m) => m.kind === 'rescue'),
    purchaseFailed: a.session.purchaseFailed === true,
    onboarding: currentStep(a.services.store.state) !== 'done',
  };
}
